// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__R3Ah4","text":"styles_text__pDI4T","icon":"styles_icon__mhS-S"};